import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { createPermiso } from 'repositories/permiso_kinder_repository';
import type { Permiso } from 'models/permiso_model';

interface PermisoKinderState {
  loading: boolean;
  error: string | null;
}

const initialState: PermisoKinderState = {
  loading: false,
  error: null,
};

 
export const agregarPermisoKinder = createAsyncThunk(
  'permisoKinder/agregarPermiso',
  async (data: Permiso, { rejectWithValue }) => {
    try {
      await createPermiso(data);
    } catch {
      return rejectWithValue('Error al crear permiso kinder');
    }
  },
);

export const permisoKinderSlice = createSlice({
  name: 'permisoKinder',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(agregarPermisoKinder.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(agregarPermisoKinder.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(agregarPermisoKinder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default permisoKinderSlice.reducer;
